function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#383838",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.563 16.188h10a.5.5 0 0 0 .5-.5v-12.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v12.5a.5.5 0 0 0 .5.5zm.5-1v-11.5h9v11.5h-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.063 3.688h5a.5.5 0 0 0 .5-.5V1.312a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1.875a.5.5 0 0 0 .5.5zm.5-1.876h4v.875h-4v-.874z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 3.688h13.75a.5.5 0 1 0 0-1H1a.5.5 0 0 0 0 1zM4.563 5.375v7.5a.5.5 0 1 0 1 0v-7.5a.5.5 0 0 0-1 0zM7.063 5.375v7.5a.5.5 0 1 0 1 0v-7.5a.5.5 0 0 0-1 0zM9.563 5.375v7.5a.5.5 0 1 0 1 0v-7.5a.5.5 0 1 0-1 0z"
}));

var SvgTrashIcon = function SvgTrashIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    style: {
      background: "#fff"
    },
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash_icon.383f4187.svg";
export { ForwardRef as ReactComponent };